// extracted by mini-css-extract-plugin
module.exports = {"default":"hero_default__3Uwnj","overlay":"hero_overlay__1Sinp","textWrapper":"hero_textWrapper__iOXtN","heroWrapper":"hero_heroWrapper__2vzfF"};